<template>
  <div
    v-if="author"
    class="rounded-full overflow-hidden hidden md:block size-10 mr-2"
  >
    <img
      v-if="author.photo"
      :src="author.photo.url"
      alt="author.name"
      class="w-full h-full"
    />
    <div
      v-else
      class="bg-white p-2 flex items-center justify-center"
    >
      <fa
        :icon="['fal', 'user-md']"
        class="fa-fw text-neutral-400 text-2xl"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterCircleAvatar',

  props: {
    author: {
      type: Object,
      required: true,
    },
  },
};
</script>
